import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

export default function SuccessMessage({ message, show, setShow }) {

    const handleClose = (event, reason) => {
        if (reason === "clickaway") return; 
        setShow(false);
    };

    return (
        <Snackbar
            open={show}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            autoHideDuration={8000}
            onClose={handleClose}
        >
            <Alert
                onClose={handleClose}
                variant="outlined"
                severity="success"
                sx={{
                    width: "100%",  
                    backgroundColor: 'background.paper'
                }}
            >
                <p className="mb-0">{message}</p>
            </Alert>
        </Snackbar>
    );
}